import { setRangeMax } from './helpers';

export const setKitchenAreaMax = setRangeMax('kitchen');
